import { ComponentChildren } from 'preact';
import { stringLiteralArray } from '../utils/UNSAFE_arrayUtils';
import { multiVariantStyles } from './themes/SubheadingStyles.css';

export const subheadingElementTypes = stringLiteralArray([
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'div',
  'span'
]);

type ElementType = typeof subheadingElementTypes[number];

type SubheadingProps = {
  /**
   * Specifies the subheading tag. When a heading tag should not be used 'as' may be set to div or span, for example in collection group headers (such as list view group headers).
   */
  as: ElementType;

  /**
   * Specifies the font size and line height. The default value of this property is theme driven.
   */
  size?: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'inherit';

  /**
   * Specifies the subheader id
   */
  id?: string;

  /**
   * Specifies the children
   */
  children: ComponentChildren;
};

const headingsizeMap = {
  h1: '2xl',
  h2: 'xl',
  h3: 'lg',
  h4: 'md',
  h5: 'sm',
  h6: 'xs',
  div: 'md',
  span: 'md'
};

export const sizeOptions = ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', 'inherit'];

export const Subheading = ({ children, as, size, id }: SubheadingProps) => {
  const Component = as;
  //@ts-ignore
  size = size ?? headingsizeMap[Component];
  const classes = multiVariantStyles({ size });
  return (
    <Component className={classes} id={id}>
      {children}
    </Component>
  );
};
